import React from 'react';
import { CapacityMetric } from './production-capacity-editor.helpers';
import { backdrop, colors, dangerButton, dialog, ghostButton } from './editor.styles';
import { WarningIcon } from './icons';

interface RemoveCategoryDialogProps {
  metric: CapacityMetric;
  onConfirm: () => void;
  onCancel: () => void;
}

export const RemoveCategoryDialog = ({ metric, onConfirm, onCancel }: RemoveCategoryDialogProps) => {
  return (
    <div style={backdrop} onClick={onCancel}>
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="capacity-remove-title"
        aria-describedby="capacity-remove-description"
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.key === 'Escape' && onCancel()}
        style={{ ...dialog, width: 500, gap: 20 }}>
        <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
          <div style={{ width: 44, height: 44, flexShrink: 0, borderRadius: 12, background: 'rgba(220,0,0,0.18)', color: '#FF9C9C', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <WarningIcon size={22} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <h2 id="capacity-remove-title" style={{ margin: 0, fontSize: 21, fontWeight: 800 }}>Ne plus limiter « {metric.label} » ?</h2>
            <p id="capacity-remove-description" style={{ margin: 0, fontSize: 14, lineHeight: 1.5, color: colors.soft }}>
              Toutes les limites {metric.label.toLowerCase()} de cette capacité seront supprimées, sur tous les jours.
              Les {metric.unit} ne seront plus plafonnées par créneau.
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          {/* Le choix sûr a le focus : Entrée par réflexe ne supprime rien */}
          <button type="button" autoFocus onClick={onCancel} style={{ ...ghostButton, height: 44, padding: '0 20px', fontSize: 15 }}>Conserver</button>
          <button type="button" onClick={onConfirm} style={{ ...dangerButton, height: 44, padding: '0 22px', fontSize: 15 }}>Supprimer « {metric.label} »</button>
        </div>
      </div>
    </div>
  );
};
